import getLocalePackIdsForCompletedStreams from './getLocalePackIdsForCompletedStreams';

export default async function getLocalePackIdsForUncompletedStreams(injector, user, streamPackIds) {
    const completedStreamLocalePackIds = await getLocalePackIdsForCompletedStreams(injector, user);
    return streamPackIds.filter(id => !completedStreamLocalePackIds.includes(id));
}
